import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RouterLink } from '@angular/router';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { Vehicle } from '@polaris-customerweb/sharedcomponents.garage';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Observable } from 'rxjs';
import { SettingsComponent } from 'src/app/components/account/settings/settings.component';
import { ThemeService } from 'src/app/state/theme/theme.service';
import { UserAuthService } from 'src/app/state/user-auth/user-auth.service';

@Component({
    imports: [AngularSvgIconModule, RouterLink],
    selector: 'rdx-home-helpful-links',
    styleUrls: ['./home-helpful-links.component.scss'],
    templateUrl: './home-helpful-links.component.html',
})
export class HomeHelpfulLinksComponent implements OnChanges, OnInit {
    @Input() selectedVehicle: Vehicle | null;

    garageUrl: string;
    groupUrl: string;
    isAuthenticated$: Observable<boolean>;
    isIndian: boolean;
    isOffRoad: boolean;
    isSlingshot: boolean;

    constructor(
        private configService: ConfigService,
        private themeService: ThemeService,
        private matDialog: MatDialog,
        private userAuthService: UserAuthService
    ) {}

    ngOnInit() {
        this.isAuthenticated$ = this.userAuthService.isAuthenticated$;
        this.isOffRoad = this.configService.isOffRoad;
        this.isIndian = this.configService.isIndian;
        this.isSlingshot = this.configService.isSlingshot;
        this.groupUrl = this.themeService.getBrandLink(
            this.configService.brand,
            'ridersGroup'
        );
    }

    ngOnChanges(changes: SimpleChanges | undefined): void {
        if (changes?.selectedVehicle) {
            if (changes.selectedVehicle.currentValue) {
                const brand = this.selectedVehicle?.brand;
                this.garageUrl = brand
                    ? this.themeService.getBrandLink(brand, 'garage')
                    : '';
            }
        }
    }

    navigateTo(): void {
        this.matDialog.open(SettingsComponent);
    }
}
